const inputList = document.querySelectorAll('.js-input-file');

if (inputList.length >= 1) {
    inputList.forEach(item => {
        item.addEventListener('click', e => {
            e.preventDefault();

            const parent = item.closest('.form-row');

            const nativeInput = parent.querySelector('input[type="file"]');
            const fileInfo = parent.querySelector('.data-file-chosen');

            nativeInput.click();

            nativeInput.addEventListener('change', () => {
                fileInfo.textContent = nativeInput.files[0].name;
            });
        });
    });
}
